/* eslint-disable */

import Vue from 'vue'
import Router from 'vue-router'
import {isCmsPath} from '@shared/_helpers';
import ContentAPI from "@shared/_api/cms/content";
import Team from "./src/viewsShop/pages/Team";
import Start from "./src/viewsShop/pages/Start/Start";
import Category from "./src/viewsShop/pages/Category/Category";
import List from "./src/viewsShop/dynamic/List";
import CustomerCategory from "./src/viewsShop/pages/Category/Customer/CustomerCategory";
import Customer from "./src/viewsShop/pages/Category/Customer/Customer";
import Article from "./src/viewsShop/pages/Article/Article";
import Theme from "./src/viewsShop/pages/Theme/Theme";
import {mapActions, mapState} from "vuex";
import {store} from "./src/_store/index";
import Activation from "./src/viewsShop/pages/Activation";
import Personal from "./src/viewsShop/pages/Personal/Personal";
import CartOverview from "./src/viewsShop/pages/Cart/CartOverview";
import About from "./src/viewsShop/pages/About";
import Page from "./src/viewsShop/dynamic/Page";
import Checkout from "./src/viewsShop/pages/Checkout/Checkout";
import CheckoutSuccess from "./src/viewsShop/pages/Checkout/CheckoutSuccess";
import SampleOverview from "./src/viewsShop/pages/Sample/SampleOverview";
import SampleCheckout from "./src/viewsShop/pages/Sample/SampleCheckout";
import SampleCheckoutSuccess from "./src/viewsShop/pages/Sample/SampleCheckoutSuccess";
import Sustainability from "./src/viewsShop/pages/Sustainability";
import ContentList from "./src/viewsCMS/components/content/ContentList";
import Template from "./src/viewsCMS/components/content/Template";
import ContentPage from "./src/viewsCMS/components/content/ContentPage";
import ThemeSelect from "./src/viewsShop/pages/Theme/ThemeSelect";
import Basic from "./src/viewsShop/pages/Article/Basic";
import Search from "./src/viewsShop/pages/Search";
import ExtendedSearch from "./src/viewsShop/pages/ExtendedSearch";
import Sustainability_v2 from "./src/viewsShop/pages/Sustainability_v2";
import ContentGrid from "./src/viewsShop/dynamic/ContentGrid";
import GtlSearch from "./src/viewsShop/pages/Gtl/GtlSearch";
import Login from "./src/viewsShop/pages/Login";
import Supplier from "@client/src/viewsShop/pages/Supplier/Supplier";
import SupplierOrders from "@client/src/viewsShop/pages/Supplier/SupplierOrders";
import CustomerOrders from "@client/src/viewsShop/pages/Category/Customer/CustomerOrders";
import EmployeeDetails from "@client/src/viewsShop/pages/EmployeeDetails.vue";
import FarbkarteDetail from "@client/src/viewsShop/pages/FarbkarteDetail.vue";

Vue.use(Router);

const viewsShopPath = './src/viewsShop/';
const viewsCmsPath = './src/viewsCMS/';

let router = new Router({
    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0}
    },
    mode: 'history',
    routes: [

        {
            path: '/cmslogin',
            name: 'cmsLogin',
            component: () => import(viewsCmsPath + 'Login.vue'),
        },
        {
            path: '/signup',
            name: 'shopSignup',
            component: () => import(viewsShopPath + 'Signup.vue'),
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/cms',
            component: () => import(viewsCmsPath + 'Home.vue'),
            meta: {
                requiresAuth: true
            },
            redirect: {name: 'content-list'},
            beforeEnter: (to, from, next) => {
                const currentUser = store.state.account.user;
                if (currentUser && !currentUser.roles.some(r => r.name === 'Admin')) {
                    store.dispatch('account/logout');
                    next('/cmslogin');
                } else {
                    next();
                }

            },
            children: [
                {
                    path: 'content',
                    name: 'content',
                    component: () => import( viewsCmsPath + 'Content.vue'),
                    meta: {
                        requiresAuth: true
                    },
                    children: [
                        {
                            path: '/',
                            redirect: {name: 'content-list'}
                        },
                        {
                            path: 'list/:resource?',
                            name: 'content-list',
                            component: ContentList,
                            meta: {
                                requiresAuth: true
                            },
                        },
                        {
                            path: 'page',
                            name: 'content-page',
                            component: ContentPage,
                            meta: {
                                requiresAuth: true
                            },
                        },
                        {
                            path: 'template',
                            name: 'content-template',
                            component: Template,
                            meta: {
                                requiresAuth: true
                            },
                        }
                    ]
                },
                {
                    path: 'media',
                    name: 'media-library',
                    component: () => import( viewsCmsPath + 'MediaLibrary.vue'),
                    meta: {
                        requiresAuth: true
                    },
                },
                {
                    path: 'shops',
                    name: 'cmsShops',
                    component: () => import( viewsCmsPath + 'Shops.vue'),
                    meta: {
                        requiresAuth: true
                    },
                },
                {
                    path: 'shop',
                    component: () => import( viewsCmsPath + 'ShopManagement.vue'),
                    meta: {
                        requiresAuth: true
                    },
                    children: [
                        {
                            path: '/',
                            redirect: {name: 'dmix'}
                        },
                        {
                            path: 'dmix',
                            name: 'dmix',
                            component: () => import( viewsCmsPath + 'Dmix.vue'),
                            meta: {
                                requiresAuth: true
                            }
                        },
                    ]
                },
                {
                    path: 'aimanagement',
                    component: () => import( viewsCmsPath + 'AiManagement.vue'),
                    meta: {
                        requiresAuth: true
                    },
                    children: [
                        {
                            path: '/',
                            redirect: {name: 'ai-search'}
                        },
                        {
                            path: 'configuration',
                            name: 'ai',
                            component: () => import( viewsCmsPath + 'ai.vue'),
                            meta: {
                                requiresAuth: true
                            }
                        },{
                            path: 'search',
                            name: 'ai-search',
                            component: () => import( viewsCmsPath + 'AiSearch.vue'),
                            meta: {
                                requiresAuth: true
                            }
                        }]
                },
                {
                    path: 'users-management',
                    component: () => import( viewsCmsPath + 'UsersManagement.vue'),
                    meta: {
                        requiresAuth: true
                    },
                    children: [
                        {
                            path: '/',
                            redirect: {name: 'users'}
                        },
                        {
                            path: 'registrations',
                            component: () => import( viewsCmsPath + 'RegistrationsTable.vue'),
                            meta: {
                                requiresAuth: true
                            }
                        },
                        {
                            path: 'users',
                            name: 'users',
                            component: () => import( viewsCmsPath + 'UsersTable.vue'),
                            meta: {
                                requiresAuth: true
                            }
                        },
                        {
                            path: 'roles',
                            component: () => import( viewsCmsPath + 'RolesTable.vue'),
                            meta: {
                                requiresAuth: true
                            }
                        },
                        {
                            path: 'resources',
                            component: () => import( viewsCmsPath + 'ResourcesTable.vue'),
                            meta: {
                                requiresAuth: true
                            }
                        }
                    ]
                },
                {
                    path: 'color-cards',
                    name: 'color-cards',
                    component: () => import( viewsCmsPath + 'ColorCards.vue'),
                    meta: {
                        requiresAuth: true
                    },
                },
                {
                    path: 'profile',
                    name: 'cmsUserProfile',
                    component: () => import( viewsCmsPath + 'UserProfile.vue'),
                    meta: {
                        requiresAuth: true
                    },
                }
            ]
        }
        // {
        //   path: '*',
        //   redirect: '/' // TODO
        // }
    ]

});

let componentMapping = {
    'team': Team,
    'categories': Start,
    'category': Category,
    'list': List,
    'customer': CustomerCategory,
    'article': Article,
    'theme': Theme,
    'activation': Activation,
    'personal': Personal,
    'about': About,
    'page': Page,
    'sustainability': Sustainability,
    'sustainability_v2': Sustainability_v2,
    'content-grid': ContentGrid
};

let requiredRoutes = [
    {
        path: 'cart',
        component: CartOverview,
        name: 'cart'
    }
];

ContentAPI.fetchListByName('routes')
    .then(response => {
        let allRoutes = response.filter(route => route.path.value).map(route => {
            if (route.redirect && route.redirect.value) {
                ;
                return {
                    path: route.path.value,
                    redirect: route.redirect.value
                }
            }

            return {
                path: route.path.value,
                component: componentMapping[route.component.value],
                name: route.name.value,
            };
        });

        allRoutes.push({
            path: 'sustainability',
            component: Sustainability_v2,
            name: 'sustainability_v2',
            meta: {
                requiresAuth: false
            },
        });

        allRoutes.push({
            path: '/employee/:employeeId',
            name: 'employee-details',
            meta: {
                requiresAuth: false
            },
            component: EmployeeDetails  // assuming you put the new component in this path
        });

        allRoutes.push({
            path: 'cart/:cartId',
            component: CartOverview,
            name: 'cart',
            meta: {
                requiresAuth: true
            },
        });
        allRoutes.push({
            path: 'trend-select',
            component: ThemeSelect,
            name: 'theme-select',
            meta: {
                requiresAuth: true
            },
        });

        allRoutes.push({
            path: 'search',
            component: Search,
            name: 'search',
            meta: {
                requiresAuth: true
            },
        });

        allRoutes.push({
            path: 'extended-search',
            component: ExtendedSearch,
            name: 'extended-search',
            meta: {
                requiresAuth: true
            },
        });

        allRoutes.push({
            path: 'checkout/:cartId',
            component: Checkout,
            name: 'checkout',
            meta: {
                requiresAuth: true
            },
        });

        allRoutes.push({
            path: 'content-list/:listName',
            component: ContentGrid,
            name: 'contentList'
        });

        allRoutes.push({
            path: 'gtl',
            component: GtlSearch,
            name: 'ttlSearch'
        });

        allRoutes.push({
            path: 'sample-overview',
            component: SampleOverview,
            name: 'sample-overview',
            meta: {
                requiresAuth: true
            },
        });
        allRoutes.push({
            path: 'checkout-success',
            component: CheckoutSuccess,
            name: 'checkout-success',
            meta: {
                requiresAuth: true
            },
        });

        allRoutes.push({
            path: 'sample-checkout',
            component: SampleCheckout,
            name: 'sample-checkout',
            meta: {
                requiresAuth: true
            },
        });

        allRoutes.push({
            path: 'sample-checkout-success',
            component: SampleCheckoutSuccess,
            name: 'sample-checkout-success',
            meta: {
                requiresAuth: true
            },
        });

        allRoutes.push({
            path: 'theme/:season?/:sub?',
            component: Theme,
            name: 'theme',
            meta: {
                requiresAuth: true
            },
        });

        allRoutes.push({
            path: '/ar/:articleId?/:categoryId?/:variantId?/:cardId?',
            component: Article,
            name: 'ar',
            meta: {
                skipTracking: true
            },
        });

        allRoutes.push({
            path: '/basic/:articleId?',
            component: Basic,
            name: 'basic',
            meta: {
                skipTracking: true
            },
        });


        allRoutes.push({
            path: '/category/:id/:parentCategory?',
            component: Category,
            name: 'category',
            meta: {
                skipTracking: true
            },
        });

        allRoutes.push({
            path: '/customer/:id/:searchString?',
            component: Customer,
            meta: {
                skipTracking: true,
                requiresAuth: true
            },
            children: [
                {
                    path: '/',
                    name: 'customer',
                    component: CustomerCategory,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: '/orders/:id',
                    name: 'orders',
                    component: CustomerOrders,
                    meta: {
                        requiresAuth: true
                    }
                }
            ]

        });

        allRoutes.push({
            path: '/color-card/:qualitaetId',
            component: FarbkarteDetail,
            name: 'farbkarte-detail',
            meta: {
                requiresAuth: true
            },
        });

        allRoutes.push({
            path: '/personal',
            component: Personal,
            name: 'personal',
            meta: {
                skipTracking: true,
                requiresAuth: true
            },
        });

        allRoutes.push({
            path: '/1/1/:articleId',
            redirect: to => ({
                name: "ar",
                params: { articleId: to.params.articleId },
            })
        });

        allRoutes.push({
            path: '/login',
            name: 'shopLogin',
            component: Login,
            meta: {
                requiresAuth: false
            }
        });

        let supplierRoutes = {
            path: '/supplier/:supplierId',
            component: Supplier,
            meta: {
                requiresAuth: true
            },
            children: [
                {
                    path: 'orders',
                    name: 'supplier-orders',
                    component: SupplierOrders,
                    meta: {
                        requiresAuth: true
                    }
                }
            ]
        }
        allRoutes.push(supplierRoutes);
        allRoutes.push({path: "*", redirect: '/'});

        let shopRoutes = {
            path: '/',
            component: () => import( viewsShopPath + 'BaseLayout.vue'),
            children: allRoutes
        };


        router.addRoutes([shopRoutes]);
    })
    .catch(e => {
        console.log(e);
    });


router.beforeEach((to, from, next) => {
    const currentUser = store.state.account.user;
    const loggedIn = $cookies.get('user');
    Vue.prototype.$tracker.updatePath(to.path);

    if (!to.matched.some(record => record.meta.skipTracking)) {
        Vue.prototype.$tracker.trackView({label: to.path, type: 'DEFAULT'}, currentUser);
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {

        if (!currentUser) {
            $cookies.set('initialUrl', window.location.href);
            if (isCmsPath(to.path)) {
                return next('/cmslogin');
            } else {
                return next('/login');
            }
        }
    }
    next();
});

export default router;